'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import PropTypes from 'prop-types';
import { Component } from 'react';
import EmailCreationBody from 'EmailComponents/emailCreation/EmailCreationBody';
import { CREATION_STEPS, EMAIL_TEMPLATE_MODE_MODAL_WIDTH, EMAIL_TYPE_PANEL_WIDTH, FINAL_CREATION_STEPS as FINAL_STEPS } from 'EmailData/constants/emailCreation';
import EmailType from 'EmailData/enums/EmailType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class EmailCreationModal extends Component {
  constructor(props) {
    super(props);
    this.renderRssFooter = () => {
      const {
        selectedBlog,
        canContinue,
        validRssUrl,
        currentCreationStep,
        rssFeedUrl,
        availableBlogTypes,
        selectedFrequency
      } = this.props;
      const enableContinue = currentCreationStep === CREATION_STEPS.BLOG_RSS_FEED_SELECT && selectedBlog === -1 ? validRssUrl.length > 0 && validRssUrl === rssFeedUrl : canContinue;
      let continueText = 'continueButton';
      if (currentCreationStep === CREATION_STEPS.BLOG_RSS_FEED_SELECT && selectedBlog !== -1) {
        if (!availableBlogTypes || availableBlogTypes.indexOf(selectedFrequency) < 0) {
          continueText = 'editButton';
        }
      }
      const continueButton = /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: this.props.onConfirm,
        disabled: !enableContinue,
        "data-test-id": "creation-continue",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `EmailComponents.modals.creation.${continueText}`
        })
      });
      return /*#__PURE__*/_jsxs(UIPanelFooter, {
        children: [continueButton, /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: this.props.onClose,
          "data-test-id": "creation-cancel",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.cancelButton"
          })
        })]
      });
    };
    this.renderFooter = () => {
      const disabled = [EmailType.OPTIN_EMAIL, EmailType.OPTIN_FOLLOWUP_EMAIL, EmailType.RESUBSCRIBE_EMAIL].includes(this.props.emailType) ? !this.props.selectedTemplateMode : !this.props.selectedEmailType;
      return /*#__PURE__*/_jsxs(UIPanelFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: this.props.onClickCreate,
          disabled: disabled,
          "data-test-id": "create-or-next-button",
          children: [EmailType.OPTIN_EMAIL, EmailType.OPTIN_FOLLOWUP_EMAIL, EmailType.RESUBSCRIBE_EMAIL].includes(this.props.emailType) ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.createButton"
          }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.nextButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: this.props.onClose,
          "data-test-id": "creation-cancel",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.modals.creation.cancelButton"
          })
        })]
      });
    };
    this.renderHeader = () => {
      const {
        emailType,
        stepIndex
      } = this.props;
      let message = 'EmailComponents.modals.creation.title';
      if (emailType && [EmailType.OPTIN_EMAIL, EmailType.OPTIN_FOLLOWUP_EMAIL, EmailType.RESUBSCRIBE_EMAIL].includes(emailType)) {
        message = `EmailComponents.modals.creation.chooseEmailTemplateType.create.type.${emailType}`;
      }
      return /*#__PURE__*/_jsxs(UIPanelHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          "data-test-id": "email-creation-modal-close-button",
          onClick: this.props.onClose
        }), stepIndex > 0 ? /*#__PURE__*/_jsx(UIIconButton, {
          "data-test-id": "back-icon-button",
          use: "unstyled",
          onClick: this.props.onClickBack,
          children: /*#__PURE__*/_jsx(UIIcon, {
            className: "p-right-4",
            size: "small",
            name: "previous"
          })
        }) : null, /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message
          })
        })]
      });
    };
    this.renderBody = () => {
      const {
        availableEmailTypes,
        canAccessBusinessUnit,
        currentCreationStep,
        emailBusinessUnitId,
        emailName,
        emailType,
        onClickClassic,
        onClickDragDrop,
        onClose,
        onSelectBlog,
        onSelectEmailType,
        onSelectFrequency,
        onSelectRssFeedUrl,
        previewDdUrl,
        rssFeedUrl,
        selectedBlog,
        selectedEmailType,
        selectedFrequency,
        selectedTemplateMode,
        shouldUseBUPicker,
        emailDetails
      } = this.props;
      return /*#__PURE__*/_jsx(EmailCreationBody, {
        availableEmailTypes: availableEmailTypes,
        businessUnitId: this.state.businessUnitId,
        canAccessBusinessUnit: canAccessBusinessUnit,
        canUseRss: this.canUseRss(),
        currentCreationStep: currentCreationStep,
        emailBusinessUnitId: emailBusinessUnitId,
        emailDetails: emailDetails,
        emailName: emailName,
        emailType: emailType,
        onClickClassic: onClickClassic,
        onClickDragDrop: onClickDragDrop,
        onClose: onClose,
        onSelectBlog: onSelectBlog,
        onSelectBusinessUnit: buId => {
          this.setState({
            businessUnitId: buId
          });
          this.props.onSelectBusinessUnit(buId);
        },
        onSelectEmailType: onSelectEmailType,
        onSelectFrequency: onSelectFrequency,
        onSelectRssFeedUrl: onSelectRssFeedUrl,
        previewDdUrl: previewDdUrl,
        rssFeedUrl: rssFeedUrl,
        selectedBlog: selectedBlog,
        selectedEmailType: selectedEmailType,
        selectedFrequency: selectedFrequency,
        selectedTemplateMode: selectedTemplateMode,
        shouldUseBUPicker: shouldUseBUPicker
      });
    };
    this.state = {
      businessUnitId: 0
    };
  }
  canUseRss() {
    return this.props.availableEmailTypes.indexOf(EmailType.RSS_EMAIL) > -1;
  }
  render() {
    const {
      currentCreationStep,
      useWideModal
    } = this.props;
    const shouldRenderRssFooter = FINAL_STEPS.indexOf(currentCreationStep) > -1;
    const width = useWideModal ? EMAIL_TYPE_PANEL_WIDTH : EMAIL_TEMPLATE_MODE_MODAL_WIDTH;
    return /*#__PURE__*/_jsxs(UIPanel, {
      width: width,
      "data-test-id": "email-creation-panel",
      children: [this.renderHeader(), /*#__PURE__*/_jsx(UIPanelBody, {
        children: /*#__PURE__*/_jsx(UIPanelSection, {
          children: this.renderBody()
        })
      }), shouldRenderRssFooter && this.renderRssFooter(), !shouldRenderRssFooter && this.renderFooter()]
    });
  }
}
EmailCreationModal.propTypes = {
  availableBlogTypes: PropTypes.array,
  availableEmailTypes: PropTypes.array,
  canAccessBusinessUnit: PropTypes.bool.isRequired,
  canContinue: PropTypes.bool,
  currentCreationStep: PropTypes.string,
  emailBusinessUnitId: PropTypes.number,
  emailDetails: PropTypes.object,
  emailName: PropTypes.string,
  emailType: PropTypes.string,
  onClickBack: PropTypes.func,
  onClickClassic: PropTypes.func.isRequired,
  onClickCreate: PropTypes.func,
  onClickDragDrop: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onSelectBlog: PropTypes.func,
  onSelectBusinessUnit: PropTypes.func.isRequired,
  onSelectEmailType: PropTypes.func,
  onSelectFrequency: PropTypes.func,
  onSelectRssFeedUrl: PropTypes.func,
  previewDdUrl: PropTypes.string,
  rssFeedUrl: PropTypes.string,
  selectedBlog: PropTypes.number,
  selectedEmailType: PropTypes.string,
  selectedFrequency: PropTypes.string,
  selectedTemplateMode: PropTypes.string,
  shouldUseBUPicker: PropTypes.bool,
  stepIndex: PropTypes.number,
  useWideModal: PropTypes.bool,
  validRssUrl: PropTypes.string
};
EmailCreationModal.defaultProps = {
  availableEmailTypes: [],
  currentCreationStep: CREATION_STEPS.TEMPLATE_TYPE,
  showNonConvertibleMessage: false,
  useWideModal: true
};